import React from 'react';

import {EContentType} from 'src/constants';
import {THeader} from 'src/containers/MessageMatchers/definitions';
import {DocumentIcon, ImageIcon, VideoIcon} from 'src/icons';

import * as SS from '../style';
import * as S from './style';

export const Header = React.memo<{header: THeader}>(({header}) => {
  const attachmentUrl = header.attachment?.fileUrl;

  if (header.headerType === EContentType.TEXT && header.text) {
    return <S.TextBodyHeader>{header.text}</S.TextBodyHeader>;
  }

  if (header.headerType === EContentType.IMAGE) {
    return (
      <S.HeaderBackground isFullHeight={!!attachmentUrl}>
        {!!attachmentUrl ? <SS.Image src={attachmentUrl} /> : <SS.Icon as={ImageIcon} />}
      </S.HeaderBackground>
    );
  }

  if (header.headerType === EContentType.VIDEO) {
    return (
      <S.HeaderBackground>
        <SS.Icon as={VideoIcon} />
      </S.HeaderBackground>
    );
  }

  if (header.headerType === EContentType.DOCUMENT) {
    return (
      <S.HeaderBackground>
        <SS.Icon as={DocumentIcon} />
      </S.HeaderBackground>
    );
  }

  return null;
});

Header.displayName = 'Header';
